import * as consentManagementTypes from './consentManagementTypes';

const initialState = {
  tableData: [],
  filters: {},
  showFilterModal: false,
  isLoading: false,
  consentManagementFilter: {},
  bannerDetails: {},
  tabData: {},
};

const consentManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case consentManagementTypes.GET_CONSENT_MANAGEMENT_FILTERS_SUCCESS:
      return {
        ...state,
        filters: action.payload,
      };

    case consentManagementTypes.SET_CONSENT_MANAGEMENT_PARAMS_SUCCESS:
      return { ...state, dataPayload: action.payload };

    case consentManagementTypes.SET_CONSENT_MANAGEMENT_POPULATE_PAYLOAD_SUCCESS:
      return { ...state, populatePayload: action.flag };

    case consentManagementTypes.GET_CONSENT_MANAGEMENT_DATA_SUCCESS:
      return { ...state, tableData: action.payload };

    case consentManagementTypes.HYDRATE_CONSENT_MANAGEMENT_PARAMS:
      return { ...state, dataPayload: action.payload };

    case consentManagementTypes.GET_CONSENT_MANAGEMENT_BANNER_SUCCESS:
      return { ...state, bannerDetails: action.payload };

    case consentManagementTypes.GET_CONSENT_MANAGEMENT_TAB_DATA_SUCCESS:
      return { ...state, tabData: action.payload };

    case consentManagementTypes.SHOW_FILTER_MODAL:
      return {
        ...state,
        showFilterModal: action.status,
        anchorModal: action.anchorEl,
      };

    default:
      return state;
  }
};

export default consentManagementReducer;
